<script setup lang="ts">
import { type IReceiptItem } from '@/api/interfaces'

import DownloadIcon from '@/components/icons/DownloadIcon.vue'

type ItemVariants = 'compact'

interface Props {
  receipt: IReceiptItem
  variant?: ItemVariants
}

defineProps<Props>()
</script>

<template>
  <div
    class="receipt-item"
    :class="variant ? `receipt-item receipt-item--${variant}` : 'receipt-item'"
  >
    <span class="receipt-title">
      {{ receipt.name }}
    </span>
    <a
      v-if="receipt.url"
      class="receipt-action"
      :href="receipt.url"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ $t('PublicLedger.view') }} <DownloadIcon />
    </a>
  </div>
</template>

<style lang="scss" scoped>
.receipt-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--ui-white);
  padding: 16px 24px;
  border-radius: 4px;

  &--compact {
    border-radius: 0;
    background-color: transparent;
    padding: 14px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
}

.receipt-title {
  font-size: 18px;
  font-weight: 400;
}

.receipt-action {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: var(--ui-green);
  text-decoration: none;
}
</style>
